import { useFormik } from 'formik'
import { useState } from 'react'
import { applyDefaults, useAbortController, useHandleResponseError } from '../../utils'
import useImagesHistory from '../../components/History/useImagesHistory'
import fetchToCurl from 'fetch-to-curl'
import { getRequestHeaders } from '../../requestHeder'

export const useTensorAlchemy = () => {
    const { handleResponseError } = useHandleResponseError()
    const { createAbortController, abort } = useAbortController()

    const [isLoading, setIsLoading] = useState(false)

    const { image, saveImage, uploadBlobUrl } = useImagesHistory()

    const [displayPrompt, setDisplayPrompt] = useState('')

    const initialValues = {
        prompt: '',
        negative_prompt: '',
        height: 1024,
        width: 1024,
        generation_type: 'text_to_image',
        guidance_scale: 2.5,
        seed: 1024,
        steps: 50,
    }

    const request_headers = getRequestHeaders()

    const handleSubmit = async (values: any, signal: AbortSignal) => {
        try {
            const finalValues = applyDefaults(values, initialValues)

            const query = `${
                import.meta.env.REACT_APP_SUBNET_API
            }/s26_bet?synapse_type=ImageGeneration`

            const options = {
                method: 'POST',
                headers: request_headers as any,
                body: JSON.stringify({
                    ImageGeneration: {
                        prompt: finalValues.prompt,
                        negative_prompt: finalValues.negative_prompt,
                        height: Number(finalValues.height),
                        width: Number(finalValues.width),
                        generation_type: finalValues.generation_type,
                        guidance_scale: Number(finalValues.guidance_scale),
                        seed: Number(finalValues.seed),
                        steps: Number(finalValues.steps),
                    },
                }),
                signal,
            }

            const curlString = fetchToCurl(query, options)?.replace(/\$/g, '\\$')

            const response: any = await fetch(query, options)

            await handleResponseError(response)

            const data = await response.blob()

            const imageObjectURL = URL.createObjectURL(data)

            if (!imageObjectURL) return

            const uploadedUrl = await uploadBlobUrl(imageObjectURL)

            const newImage = {
                style: '',
                width: finalValues.width,
                height: finalValues.height,
                model: '',
                prompt: finalValues.prompt,
                url: uploadedUrl,
                cUrl: curlString,
            }
            saveImage(newImage)
        } catch (e) {
            console.log(e)
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values, formikHelpers) => {
            setDisplayPrompt(values.prompt)
            formikHelpers.setFieldValue('prompt', '') // Reset message to empty string immediately
            setIsLoading(true)
            const signal = createAbortController()
            await handleSubmit(values, signal)
            setIsLoading(false)
            setDisplayPrompt('')
        },
    })

    return {
        formik,
        responseLoading: isLoading,
        image,
        displayPrompt,

        handleStopRequest: abort,
    }
}
